import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "@env/environment";
import { PatientAbsence } from "@featuresAY/patient-web-ay/models/patient-absence.model";

@Injectable({ providedIn: "root" })
export class PatientAbsenceApiService {
	constructor(private http: HttpClient) {}

	getPatientAbsencesByPatientId(id: number): Observable<PatientAbsence[]> {
		return this.http.get<PatientAbsence[]>(`${environment.apiEmotion()}/patientAbsence/getByPatientId/${id}`);
	}

	createPatientAbsence(patientAbsence: PatientAbsence): Observable<PatientAbsence> {
		return this.http.post<PatientAbsence>(`${environment.apiEmotion()}/patientAbsence/create`, patientAbsence);
	}

	updatePatientAbsence(patientAbsence: PatientAbsence): Observable<PatientAbsence> {
		return this.http.post<PatientAbsence>(`${environment.apiEmotion()}/patientAbsence/update`, patientAbsence);
	}

	deletePatientAbsence(id: number): Observable<void> {
		return this.http.get<void>(`${environment.apiEmotion()}/patientAbsence/delete/${id}`);
	}
}
